import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import swal from 'sweetalert';
import { Select, Input, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import moment from 'moment';
import axios from 'axios';
import api from '../../config.json'
import validation from '../../utill/validation';
import Joi from 'joi';
import Loading from '../../utill/LoadingComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { cloneDeep } from 'lodash';
const CustomInspectionMaster = ({ history, Heading }) => {
    const location = useLocation()
    const [listNames, setAllListNames] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [errors, setErrors] = useState({})
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({ UniqueCheckCondtion: "OR", UniqueField: [], CustomFields: [{}], ResultConfigure: [{ Result: "", TreatAs: "", Color: "" }] });
    const [files, setFiles] = useState([]);
    const [roles, setRoles] = useState([])


    useEffect(() => {
        if (location.state && location.state.action == 'edit') {
            if (!location.state.data.UniqueCheckCondtion) {
                location.state.data.UniqueCheckCondtion = "OR"
            }
            setFormData(location.state.data);
        }
        if (location.state && location.state.action == 'copy') {
            if (!location.state.data.UniqueCheckCondtion) {
                location.state.data.UniqueCheckCondtion = "OR"
            }
            setFormData(location.state.data);
        }
        getAllRoles()
    }, [location])

    const dataTypes = [
        { label: "String", value: 'string' },
        { label: "Number", value: 'number' },
        { label: "Float", value: 'float' },
        { label: "Date", value: 'date' },
        { label: "Time", value: 'time' },
        { label: "List", value: 'list' },
        { label: "High Speed String", value: 'high_speed_string' },
        { label: "Time Based Input", value: 'time_based_input' }

    ]
    useEffect(() => {
        Heading('Inspection Master')
    }, [])


    const schema = {
        InspectionType: Joi.string().required(),
        ApprovalReq: Joi.string().required(),
        ContinousDataEntry: Joi.string().required(),
        SampleSerial: Joi.string().required(),
        DateTime: Joi.string().required(),
        SampleSerialUnique: Joi.string().required(),
        ShowAccuracyResult: Joi.string(),
        DefaultSelection: Joi.string().required(),
        IsDescriptionSelectAll: Joi.string(),
        NGResultWarning: Joi.string(),
        ImageCapture: Joi.string(),
        EnableSave: Joi.string(),
        NGResultAlert: Joi.string(),
        CustomFields: Joi.array().items(
            Joi.object({
                _id: Joi.string(),
                FieldName: Joi.string().required().label("Should Not be Empty Field"),
                DataType: Joi.string().required().label("Should Not be Empty Field"),
                Compulsory: Joi.boolean().label("Should Not be Empty Field"),
                CarryForward: Joi.boolean().label("Should Not be Empty Field"),
                Constant: Joi.boolean(),
                UsedForGroupBy: Joi.boolean()
            })
        ).min(1).required().label("All Fields are mandatory"),
        UniqueField: Joi.array(),
        UniqueCheckCondtion: Joi.string(),
        ApprovalRoles: Joi.array(),
        ResultConfigure: Joi.array().items(
            Joi.object({
                _id: Joi.string(),
                Result: Joi.string().required().label("Should Not be Empty Field"),
                TreatAs: Joi.string().required().label("Should Not be Empty Field"),
                Color: Joi.string().required().label("Should Not be Empty Field"),
                IsEnableAll: Joi.boolean()
            })
        ).min(1).required().label("All Fields Mandatory"),
        InstrumentReq: Joi.string(),
        _id: Joi.string(),
    }

    const getAllRoles = () => {
        axios.get(api.api + "userrole")
            .then((result) => {
                setRoles(result.data.map(x => { return { label: x.UserRole, value: x.UserRole } }))
            })
            .catch((err) => {
                console.log(err);
            })
    }


    const handleSave = () => {
        delete formData.__v
        delete formData.createdAt
        delete formData.updatedAt
        delete formData.ApprovalRole

        const error = validation.validate(formData, schema)
        if (error) {
            setErrors(error || {});
            return;
        }
        setLoader(true)
        formData.CustomFields = formData.CustomFields.filter(x => x.FieldName && x.DataType)
        formData.ResultConfigure = formData.ResultConfigure.filter(x => x.TreatAs && x.Color && x.TreatAs)
        if (location.state.action == "edit") {
            axios.patch(api.api + 'customInspection/' + formData._id, { old: location.state.data, new: formData })
                .then((result) => {
                    swal('Save Successfully');
                    history.push('/setting/custom_inspection/list');
                    setLoader(false)
                })
                .catch((err) => {
                    swal(`${err}`);
                    setLoader(false)
                })
        } else {
            axios.post(api.api + 'customInspection', formData)
                .then((result) => {
                    swal('Save Successfully');
                    history.push('/setting/custom_inspection/list');
                    setLoader(false)
                })
                .catch((err) => {
                    swal(`${err}`);
                    setLoader(false)
                })
        }

    }




    const handleFileChange = (event) => {
        setFiles([...files, ...event.target.files]);
    };

    const handleRemoveFile = (indexToRemove) => {
        setFiles(files.filter((_, index) => index !== indexToRemove));
    };

    const handleOnChange = (e) => {
        const obj = { ...formData }
        const { name, value } = e.currentTarget;
        obj[name] = value;
        const error = validation.validateProperty(e.currentTarget, schema);
        setErrors(error || {})
        if (name == "ApprovalReq") {
            obj.ApprovalRoles = []
        }
        setFormData(obj);
    }

    const handleOnChangeInspection = (propertyName, name, value) => {
        const obj = { ...formData }
        if (obj[propertyName]) {
            obj[propertyName][name] = value;
        } else {
            obj[propertyName] = { [name]: value };
        }
        setFormData(obj);
    }

    const handleResultChange = (index, e, key) => {
        const data = cloneDeep(formData)
        data[key][index][e.target.name] = e.target.value;
        if (data[key][index].DataType == "time_based_input") {
            const findIndex = data[key].findIndex(x => x.FieldName == `Date_${formData[key][index].FieldName}`)
            if (findIndex > -1) {
                data[key][findIndex] = { FieldName: `Date_${data[key][index].FieldName}`, DataType: "Default" }
            } else {
                data[key].push({ FieldName: `Date_${data[key][index].FieldName}`, DataType: "Default" })
            }
        }
        setFormData(data)
    }

    return (
        <div className='p-3' >
            {loader ? <Loading labelShow={true} label={"Loading..."} /> : ''}
            {/* <div className='text-center' >
                <p >Inspection Master</p>
            </div> */}
            {/* <ToastContainer /> */}

            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left">  <label className='small'>Inspection Type Title</label></div>
                <div className="col-sm-4">
                    <div className="form-group text-left">
                        <input name='InspectionType' value={formData.InspectionType} className='form-control form-control-sm' onChange={handleOnChange} type='text' placeholder='Enter Title..' />
                    </div>
                    {errors.InspectionType && <div className="alert small alert-danger">{errors['InspectionType']}</div>}
                </div>
            </div>
            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left"> <label className='small'>Approval Required</label></div>
                <div className="col-sm-4">
                    <div className="form-group text-left">
                        <div>
                            <label >
                                <input
                                    type="radio"
                                    name="ApprovalReq"
                                    checked={formData.ApprovalReq == "No"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "No" } })}
                                />
                                &nbsp; &nbsp;
                                No
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="ApprovalReq"
                                    checked={formData.ApprovalReq == "All"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "All" } })}
                                />
                                &nbsp; &nbsp;
                                All
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="ApprovalReq"
                                    checked={formData.ApprovalReq == "Any"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "Any" } })}
                                />
                                &nbsp; &nbsp;
                                Any
                            </label>
                        </div>
                    </div>
                    {errors.ApprovalReq && <div className="alert small alert-danger">{errors['ApprovalReq']}</div>}
                </div>
                {["Any", "All"].includes(formData.ApprovalReq) && <div className='col-sm-4'>

                    <Select
                        mode='multiple'
                        placeholder="Select User Role"
                        value={formData.ApprovalRoles || []}
                        onChange={(values, all) => {
                            handleOnChange({ currentTarget: { name: "ApprovalRoles", value: values } })
                        }}
                        style={{ width: '100%' }}
                        options={roles}
                    />
                </div>}
            </div>
            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left"> <label className='small'>Date / Time</label></div>
                <div className="col-sm-4">
                    <div className="form-group text-left">
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="DateTime"
                                    checked={formData.DateTime == 'Manual'}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "Manual" } })}
                                />
                                &nbsp; &nbsp;
                                Manual
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="DateTime"
                                    checked={formData.DateTime == 'Auto'}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "Auto" } })}
                                />
                                &nbsp; &nbsp;
                                Auto
                            </label>
                        </div>
                    </div>
                    {errors.DateTime && <div className="alert small alert-danger">{errors['DateTime']}</div>}
                </div>
            </div>
            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left">  <label className='small'>Continous Data Entry</label></div>
                <div className="col-sm-4">
                    <div className="form-group text-left">
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="ContinousDataEntry"
                                    checked={formData.ContinousDataEntry == "enable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "enable" } })}
                                />
                                &nbsp; &nbsp;
                                Enable
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="ContinousDataEntry"
                                    checked={formData.ContinousDataEntry == "disable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "disable" } })}
                                />
                                &nbsp; &nbsp;
                                Disable
                            </label>
                        </div>
                    </div>
                    {errors.ContinousDataEntry && <div className="alert small alert-danger">{errors['ContinousDataEntry']}</div>}
                </div>
            </div>

            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left"> <label className='small'>Sample Serial</label></div>
                <div className="col-sm-4">
                    <div className="form-group text-left">
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="SampleSerial"
                                    checked={formData.SampleSerial == 'Manual'}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "Manual" } })}
                                />
                                &nbsp; &nbsp;
                                Manual
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="SampleSerial"
                                    checked={formData.SampleSerial == 'Auto'}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "Auto" } })}
                                />
                                &nbsp; &nbsp;
                                Auto
                            </label>
                        </div>
                    </div>
                    {errors.SampleSerial && <div className="alert small alert-danger">{errors['SampleSerial']}</div>}
                </div>
            </div>
            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left"> <label className='small'>Sample Serial Unique</label></div>
                <div className="col-sm-4">
                    <div className="form-group text-left">
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="SampleSerialUnique"
                                    checked={formData.SampleSerialUnique == "Yes"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "Yes" } })}
                                />
                                &nbsp; &nbsp;
                                Yes
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="SampleSerialUnique"
                                    checked={formData.SampleSerialUnique == "No"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "No" } })}
                                />
                                &nbsp; &nbsp;
                                No
                            </label>
                        </div>
                    </div>
                    {errors.SampleSerialUnique && <div className="alert small alert-danger">{errors['SampleSerialUnique']}</div>}
                </div>
            </div >
            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left"> <label className='small'>Show Accuracy Result</label></div>
                <div className="col-sm-4">
                    <div className="form-group text-left">
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="ShowAccuracyResult"
                                    checked={formData.ShowAccuracyResult == "Yes"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "Yes" } })}
                                />
                                &nbsp; &nbsp;
                                Yes
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="ShowAccuracyResult"
                                    checked={formData.ShowAccuracyResult == "No"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "No" } })}
                                />
                                &nbsp; &nbsp;
                                No
                            </label>
                        </div>
                    </div>
                    {errors.ShowAccuracyResult && <div className="alert small alert-danger">{errors['ShowAccuracyResult']}</div>}
                </div>
            </div >

            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left"> <label className='small'>Instrument Master</label></div>
                <div className="col-sm-4">
                    <div className="form-group text-left">

                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="InstrumentReq"
                                    checked={formData.InstrumentReq == "enable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: "InstrumentReq", value: "enable" } })}
                                />
                                &nbsp; &nbsp;
                                Enable
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="InstrumentReq"
                                    checked={formData.InstrumentReq == "disable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: "InstrumentReq", value: "disable" } })}
                                />
                                &nbsp; &nbsp;
                                Disable
                            </label>
                        </div>
                    </div>
                    {errors.SampleSerialUnique && <div className="alert small alert-danger">{errors['SampleSerialUnique']}</div>}
                </div>
            </div >
            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left">
                    <label className='small'>Generate Warning For NG Result</label>
                </div>
                <div className="col-sm-6">
                    <div className="form-group text-left">
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="NGResultWarning"
                                    checked={formData.NGResultWarning == "enable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "enable" } })}
                                />
                                &nbsp; &nbsp;
                                Enable
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="NGResultWarning"
                                    checked={formData.NGResultWarning == "disable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "disable" } })}
                                />
                                &nbsp; &nbsp;
                                Disable
                            </label>
                        </div>
                    </div>
                    {errors.NGResultWarning && <div className="alert small alert-danger">{errors['NGResultWarning']}</div>}
                </div>
            </div>
            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left">
                    <label className='small'>Generate NG Result Alert</label>
                </div>
                <div className="col-sm-6">
                    <div className="form-group text-left">
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="NGResultAlert"
                                    checked={formData.NGResultAlert == "enable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "enable" } })}
                                />
                                &nbsp; &nbsp;
                                Enable
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="NGResultAlert"
                                    checked={formData.NGResultAlert == "disable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "disable" } })}
                                />
                                &nbsp; &nbsp;
                                Disable
                            </label>
                        </div>
                    </div>
                    {errors.NGResultAlert && <div className="alert small alert-danger">{errors['NGResultAlert']}</div>}
                </div>
            </div>
            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left">
                    <label className='small'>Enable Save</label>
                </div>
                <div className="col-sm-6">
                    <div className="form-group text-left">
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="EnableSave"
                                    checked={formData.EnableSave == "enable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "enable" } })}
                                />
                                &nbsp; &nbsp;
                                Enable
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="EnableSave"
                                    checked={formData.EnableSave == "disable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "disable" } })}
                                />
                                &nbsp; &nbsp;
                                Disable
                            </label>
                        </div>
                    </div>
                    {errors.EnableSave && <div className="alert small alert-danger">{errors['EnableSave']}</div>}
                </div>
            </div>
            <div className="row">
                {/* <div className="col-sm-2"></div> */}
                <div className="col-sm-2 text-left">
                    <label className='small'>Image Capture</label>
                </div>
                <div className="col-sm-6">
                    <div className="form-group text-left">
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="ImageCapture"
                                    checked={formData.ImageCapture == "enable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "enable" } })}
                                />
                                &nbsp; &nbsp;
                                Enable
                            </label>
                            <label className="ml-3">
                                <input
                                    type="radio"
                                    name="ImageCapture"
                                    checked={formData.ImageCapture == "disable"}
                                    onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: "disable" } })}
                                />
                                &nbsp; &nbsp;
                                Disable
                            </label>
                        </div>
                    </div>
                    {errors.ImageCapture && <div className="alert small alert-danger">{errors['ImageCapture']}</div>}
                </div>
            </div>
            <div className='border border-dark p-2'>
                <div className="row">
                    <div className="col-sm-2 text-left">
                        <label className='small'>Result(s) Configuration For Description Type Checkpoint</label>
                    </div>
                    <div className='col-sm-8'>
                        {formData.ResultConfigure.map((result, idx) => {
                            return <div className='row'>
                                <div className="col-sm-3 text-center">
                                    {idx == 0 && <label>Result</label>}
                                    <input className='form-control form-control-sm p-0'
                                        value={result.Result}
                                        placeholder='enter...'
                                        type="text"
                                        name="Result"
                                        onChange={(e) => handleResultChange(idx, e, "ResultConfigure")}
                                    />
                                </div>
                                <div className="col-sm-3 text-center">
                                    {idx == 0 && <label>Treat As</label>}
                                    <Select
                                        placeholder="Select..."
                                        value={result.TreatAs || []}
                                        onChange={(values, all) => {
                                            handleResultChange(idx, { target: { name: 'TreatAs', value: values } }, "ResultConfigure")
                                        }}
                                        style={{ width: '100%' }}
                                        options={[{ value: "OK", label: "OK" }, { value: "NG", label: "NG" }, { value: "NA", label: "NA" }]}
                                    />
                                </div>
                                <div className="col-sm-3 text-center">
                                    {idx == 0 && <label>Color</label>}
                                    <Select
                                        placeholder="Select..."
                                        value={result.Color || []}
                                        onChange={(values, all) => {
                                            handleResultChange(idx, { target: { name: 'Color', value: values } }, "ResultConfigure")
                                        }}
                                        style={{ width: '100%' }}
                                        options={[{ value: "pink", label: "Pink" }, { value: "lightgreen", label: "Light Green" }, { value: "yellow", label: "Yellow" }, { value: "orange", label: "Orange" }]}
                                    />
                                </div>
                                <div className="col-sm-2 text-center col-sm-1 mt-1">
                                    {idx == 0 && <><label>Enable All</label><br /></>}
                                    <input type='checkbox' checked={result.IsEnableAll ? true : false} onChange={(e) => handleResultChange(idx, { target: { name: 'IsEnableAll', value: e.currentTarget.checked } }, "ResultConfigure")} />

                                </div>
                                {idx > 0 && <div className="col-sm-1 mt-1 text-center">
                                    <FontAwesomeIcon onClick={() => {
                                        const obj = { ...formData };
                                        obj.ResultConfigure = obj.ResultConfigure.filter((_, index) => index !== idx)
                                        setFormData(obj)
                                    }} icon={faTimesCircle} color='#1890ff' />
                                </div>}
                            </div>
                        })}
                        {errors.ResultConfigure && <div className="alert small alert-danger">{errors['ResultConfigure']}</div>}
                    </div>


                    <div className="col-sm-2 mt-4">
                        <a className='small' style={{ color: "#1890ff", cursor: 'pointer' }} onClick={() => {
                            const obj = { ...formData };
                            obj.ResultConfigure.push({ Result: "", TreatAs: "", Color: "" });
                            setFormData(obj);
                        }} >+ Create New Result</a>
                    </div>
                </div>
                <div className="row">
                    {/* <div className="col-sm-2"></div> */}
                    <div className="col-sm-2 text-left">
                        <label className='small'>Default Selection For Description Parameter</label>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group text-center">
                            <div>
                                {formData.ResultConfigure.filter(x => x.Result && x.Color && x.TreatAs).map(x => {
                                    return x.Result && <label className='ml-4'>
                                        <input
                                            type="radio"
                                            name="DefaultSelection"
                                            checked={formData.DefaultSelection == x.Result}
                                            onChange={(e) => handleOnChange({ currentTarget: { name: e.currentTarget.name, value: x.Result } })}
                                        />
                                        &nbsp; &nbsp;
                                        {x.Result}
                                    </label>
                                })}
                            </div>
                        </div>
                        {errors.DefaultSelection && <div className="alert small alert-danger">{errors['DefaultSelection']}</div>}
                    </div>
                </div>

                {/* <div className="row">
                    <div className="col-sm-2 text-left"> <label className='small'>Selection All For Description Parameter</label></div>
                    <div className="col-sm-4">
                        <div className="form-group text-left">

                            <div>
                                <label>
                                    <input
                                        type="radio"
                                        name="IsDescriptionSelectAll"
                                        checked={formData.IsDescriptionSelectAll == "enable"}
                                        onChange={(e) => handleOnChange({ currentTarget: { name: "IsDescriptionSelectAll", value: "enable" } })}
                                    />
                                    &nbsp; &nbsp;
                                    Enable
                                </label>
                                <label className="ml-3">
                                    <input
                                        type="radio"
                                        name="IsDescriptionSelectAll"
                                        checked={formData.IsDescriptionSelectAll == "disable"}
                                        onChange={(e) => handleOnChange({ currentTarget: { name: "IsDescriptionSelectAll", value: "disable" } })}
                                    />
                                    &nbsp; &nbsp;
                                    Disable
                                </label>
                            </div>
                        </div>
                        {errors.IsDescriptionSelectAll && <div className="alert small alert-danger">{errors['IsDescriptionSelectAll']}</div>}
                    </div>
                </div > */}
            </div>
            <div className='border border-dark mt-1 p-2'>
                <div className="row">
                    {/* <div className="col-sm-2"></div> */}
                    <div className="col-sm-2 text-left">
                        <label className='small'>Custom Fields For Report Header</label>
                    </div>
                    <div className='col-sm-8'>
                        {formData.CustomFields.map((field, idx) => {
                            return <div className='row'>
                                <div className="col-sm-3 text-center">
                                    {idx == 0 && <label>Field Name</label>}
                                    <input className='form-control form-control-sm  p-0'
                                        disabled={field.DataType == "Default"}
                                        placeholder='enter...'
                                        type="text"
                                        name="FieldName"
                                        value={field.FieldName}
                                        onChange={(e) => handleResultChange(idx, e, "CustomFields")}
                                    />
                                </div>
                                <div className="col-sm-2 text-center">
                                    {idx == 0 && <label>Data Type</label>}
                                    <Select
                                        disabled={field.DataType == "Default"}
                                        placeholder="Select..."
                                        value={field.DataType || []}
                                        onChange={(values, all) => {
                                            handleResultChange(idx, { target: { name: 'DataType', value: values } }, "CustomFields")
                                        }}
                                        style={{ width: '100%' }}
                                        options={dataTypes}
                                    />
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    height: '100%'
                                }} className="col-sm-1 text-center">
                                    {idx == 0 && <label >Constant</label>}
                                    <input disabled={field.DataType == "list" || field.DataType == "Default" || field.Compulsory || field.DataType == "time_based_input"} checked={field.Constant ? true : false} type='checkbox' className='mt-2' onChange={(e) => handleResultChange(idx, { target: { name: 'Constant', value: e.currentTarget.checked } }, "CustomFields")} />
                                </div>

                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    height: '100%'
                                }} className="col-sm-1 text-center">
                                    {idx == 0 && <label className='ml-1'>Required</label>}
                                    <input disabled={field.Constant || field.DataType == "Default" || field.DataType == "time_based_input"} checked={field.Compulsory ? true : false} type='checkbox' className='mt-2' onChange={(e) => handleResultChange(idx, { target: { name: 'Compulsory', value: e.currentTarget.checked } }, "CustomFields")} />
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    height: '100%'
                                }} className="col-sm-2 text-center">
                                    {idx == 0 && <label>Carry Forward</label>}
                                    <input disabled={field.DataType == "Default" || field.DataType == "time_based_input"} checked={field.CarryForward ? true : false} type='checkbox' className='mt-2' onChange={(e) => handleResultChange(idx, { target: { name: 'CarryForward', value: e.currentTarget.checked } }, "CustomFields")} />

                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    height: '100%'
                                }} className="col-sm-2 text-center">
                                    {idx == 0 && <label> Group By</label>}
                                    <input disabled={field.DataType == "time_based_input"} checked={field.UsedForGroupBy ? true : false} type='checkbox' className='mt-2' onChange={(e) => handleResultChange(idx, { target: { name: 'UsedForGroupBy', value: e.currentTarget.checked } }, "CustomFields")} />

                                </div>

                                {formData.CustomFields.length > 1 && field.DataType !== "Default" && <div className={idx == 0 ? "col-sm-1 mt-4 text-center" : "col-sm-1 mt-1 text-center"}>
                                    <FontAwesomeIcon onClick={() => {
                                        const obj = { ...formData };
                                        if (obj.CustomFields[idx] && obj.CustomFields[idx].DataType == 'time_based_input') {
                                            const fieldObj = obj.CustomFields[idx]
                                            obj.CustomFields = obj.CustomFields.filter((_, index) => index !== idx)
                                            obj.CustomFields = obj.CustomFields.filter((_, index) => _.FieldName !== `Date_${fieldObj.FieldName}`)
                                            setFormData(obj)
                                        } else {
                                            obj.CustomFields = obj.CustomFields.filter((_, index) => index !== idx)
                                            setFormData(obj)
                                        }

                                    }} icon={faTimesCircle} color='#1890ff' />
                                </div>}
                            </div>
                        })}
                        {errors.CustomFields && <div className="alert small alert-danger">{errors['CustomFields']}</div>}
                    </div>
                    <div className="col-sm-2 mt-4">
                        <a className='small' style={{ color: "#1890ff", cursor: 'pointer' }} onClick={() => {
                            const obj = { ...formData };
                            obj.CustomFields.push({ FieldName: "", DataType: "", Compulsory: false, Constant: false });
                            setFormData(obj);
                        }} >+ Add Custom Field</a>
                    </div>
                </div>
            </div>
            <div className='border border-dark mt-1 p-2'>
                <div className="row ">
                    <div className="col-sm-2 text-left">
                        <label className='small'>Inspection Unique Field</label>
                    </div>
                    <div className='col-sm-8'>
                        {formData.UniqueField && formData.UniqueField.map((field, idx) => {
                            return <div className='row'>
                                <div className="col-sm-4 text-center mt-2">
                                    {idx == 0 && <label>Select Field</label>}
                                    <Select
                                        placeholder="Select..."
                                        value={field || []}
                                        onChange={(values, all) => {
                                            const obj = { ...formData };
                                            obj.UniqueField[idx] = values
                                            setFormData(obj)
                                        }}
                                        style={{ width: '100%' }}
                                        options={[...formData.CustomFields.map(x => { return { label: x.FieldName, value: x.FieldName } }).filter(x => x.label), ...[{ label: "Date", value: 'Date' }, { label: "Time", value: 'Time' }]]}
                                    />
                                </div>


                                {<div className={idx == 0 ? "col-sm-1 mt-5 text-center" : "col-sm-1 mt-1 text-center"}>
                                    <FontAwesomeIcon onClick={() => {
                                        const obj = { ...formData };
                                        obj.UniqueField = obj.UniqueField.filter((_, index) => index !== idx)
                                        setFormData(obj)
                                    }} icon={faTimesCircle} color='#1890ff' />
                                </div>}
                            </div>
                        })}
                        {errors.UniqueField && <div className="alert small alert-danger">{errors['UniqueField']}</div>}
                    </div>
                    <div className="col-sm-2 mt-4">
                        <a className='small' style={{ color: "#1890ff", cursor: 'pointer' }} onClick={() => {
                            const obj = { ...formData };
                            if (obj.UniqueField) {
                                obj.UniqueField.push("");
                            } else {
                                obj.UniqueField = [""];
                            }

                            setFormData(obj);
                        }} >+ Add Unique Field</a>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-2 text-left">
                        <label className='small'>Inspection Unique Condition</label>
                    </div>
                    <div className='col-sm-7'>
                        <Switch
                            className='mt-2'
                            checked={formData.UniqueCheckCondtion == "OR" ? true : false}
                            style={{ backgroundColor: '#007bff' }}
                            onChange={(checked) => {
                                if (checked) {
                                    handleOnChange({ currentTarget: { name: 'UniqueCheckCondtion', value: "OR" } })
                                } else {
                                    handleOnChange({ currentTarget: { name: 'UniqueCheckCondtion', value: "AND" } })
                                }
                            }}
                            checkedChildren={"OR"}
                            unCheckedChildren={"AND"}
                        />
                        {errors.UniqueCheckCondtion && <div className="alert small alert-danger">{errors['UniqueCheckCondtion']}</div>}
                    </div>

                </div>
            </div>

            <div className=' text-center mt-4'>
                <button onClick={() => history.push('/setting/custom_inspection/list')} className="btn-sm btn-primary ">Cancel</button>
                <button onClick={handleSave} className="btn-sm btn-primary ml-4">Save</button>
            </div>



            {/* {qualityData.length > 0 && <Table
                id="RejectionDetailedAnalysispiechart"
                // onSort={handleSort}
                columns={columns1}
                sortColumn={sortColumn}
                data={extractInspectionDataSeparateArray(qualityData[0])}
            />} */}

        </div>
    );
}
export default CustomInspectionMaster;